import React from 'react';
import { Instagram, Twitter, Facebook, Youtube, Mail, MapPin } from 'lucide-react';
import { Button } from '../ui/button';

const LOGO_FULL = 'https://customer-assets.emergentagent.com/job_3118c9a4-a94d-4f60-9004-669a5548876d/artifacts/a10g5iay_GWINS_Full_Metallic_2000px.png';

const Footer = () => {
  const footerLinks = {
    shop: [
      { label: 'Jerseys', href: '#' },
      { label: 'Joggers', href: '#' },
      { label: 'Accessories', href: '#' },
      { label: 'Merch', href: '#' },
    ],
    community: [
      { label: 'Community Hub', href: '/community' },
      { label: 'Team Directory', href: '/community' },
      { label: 'GWINS Army', href: '#army' },
      { label: 'Events', href: '#' },
    ],
    support: [
      { label: 'Contact Us', href: '#' },
      { label: 'Shipping Info', href: '#' },
      { label: 'Returns', href: '#' },
      { label: 'Size Guide', href: '#' },
    ],
    legal: [
      { label: 'Privacy Policy', href: '/privacy-policy' },
      { label: 'Terms of Service', href: '/terms-of-service' },
      { label: 'Referral Terms', href: '/referral-terms' },
    ],
  };

  const socialLinks = [
    { icon: Instagram, href: '#', label: 'Instagram' },
    { icon: Twitter, href: '#', label: 'Twitter' },
    { icon: Facebook, href: '#', label: 'Facebook' },
    { icon: Youtube, href: '#', label: 'YouTube' },
  ];

  return (
    <footer className="bg-[#0a0b0c] border-t border-white/5">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <img src={LOGO_FULL} alt="GWINS" className="h-12 mb-6" />
            <p className="text-white/60 text-sm leading-relaxed mb-6">
              Pro-quality paintball gear for every level—built by players, for players. 
              Join the GWINS Army and dominate the field.
            </p>
            <div className="flex gap-4">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-white/60 hover:bg-[#00d4aa]/20 hover:text-[#00d4aa] transition-all"
                  aria-label={social.label}
                >
                  <social.icon className="h-5 w-5" />
                </a>
              ))}
            </div>
          </div>

          {/* Shop Links */}
          <div>
            <h4 className="text-white font-semibold uppercase tracking-wider text-sm mb-4">Shop</h4>
            <ul className="space-y-3">
              {footerLinks.shop.map((link) => (
                <li key={link.label}>
                  <a href={link.href} className="text-white/60 hover:text-[#00d4aa] text-sm transition-colors">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Community Links */}
          <div>
            <h4 className="text-white font-semibold uppercase tracking-wider text-sm mb-4">Community</h4>
            <ul className="space-y-3">
              {footerLinks.community.map((link) => (
                <li key={link.label}>
                  <a href={link.href} className="text-white/60 hover:text-[#00d4aa] text-sm transition-colors">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Support Links */}
          <div>
            <h4 className="text-white font-semibold uppercase tracking-wider text-sm mb-4">Support</h4>
            <ul className="space-y-3">
              {footerLinks.support.map((link) => (
                <li key={link.label}>
                  <a href={link.href} className="text-white/60 hover:text-[#00d4aa] text-sm transition-colors">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold uppercase tracking-wider text-sm mb-4">Contact</h4>
            <ul className="space-y-3 text-sm text-white/60">
              <li className="flex items-center gap-2">
                <Mail className="h-4 w-4 text-[#00d4aa]" />
                <a href="mailto:info@gwinsgear.com" className="hover:text-[#00d4aa] transition-colors">
                  info@gwinsgear.com
                </a>
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="h-4 w-4 text-[#00d4aa] mt-0.5" />
                <span>USA</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/40 text-sm">
              © {new Date().getFullYear()} GWINS Gear. All rights reserved.
            </p>
            <div className="flex gap-6">
              {footerLinks.legal.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  className="text-white/40 hover:text-[#00d4aa] text-sm transition-colors"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
